import React from 'react'
import {
  Typography,
  TextField,
  FormControl,
  FormLabel,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@mui/material'

const NewCertFields = ({ formData, setFormData }) => {
  return (
    <>
      {/* Certificate Usage - editable for new certs */}
      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Certificate Usage *</InputLabel>
          <Select
            value={formData.certificateUsage}
            onChange={(e) => setFormData({ ...formData, certificateUsage: e.target.value })}
            label="Certificate Usage *"
          >
            <MenuItem value="server-internal">Server Cert - Internal</MenuItem>
            <MenuItem value="server-public">Server Cert - Public/Internet-Facing</MenuItem>
            <MenuItem value="client-internal">Client Cert - Internal</MenuItem>
            <MenuItem value="client-broadridge">Client Cert - Broadridge-Managed for External Use</MenuItem>
            <MenuItem value="client-external">Client Cert - Externally-Managed</MenuItem>
            <MenuItem value="other">Other - please explain in notes</MenuItem>
          </Select>
          <FormHelperText>Select the type of certificate usage</FormHelperText>
        </FormControl>
      </Grid>

      {/* Client Involvement - auto-set based on cert usage */}
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel>Client Involvement *</FormLabel>
          <RadioGroup
            row
            value={formData.clientInvolvement}
            onChange={(e) => setFormData({ ...formData, clientInvolvement: e.target.value })}
          >
            <FormControlLabel 
              value="true" 
              control={<Radio />} 
              label="True" 
              disabled
            />
            <FormControlLabel 
              value="false" 
              control={<Radio />} 
              label="False" 
              disabled
            />
          </RadioGroup>
          <FormHelperText>
            Auto-set based on Certificate Usage type
          </FormHelperText>
        </FormControl>
      </Grid>

      {/* Client Name */}
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Client Name *"
          value={formData.clientName}
          onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
          disabled={formData.clientInvolvement !== 'true'}
          helperText={
            formData.clientInvolvement === 'true' 
              ? 'Required for client certificates and "Other" usage type'
              : 'Not applicable for this certificate usage type'
          }
        />
      </Grid>
    </>
  )
}

export default NewCertFields
